import React, { useState, useEffect, useMemo } from 'react';

import { getTransac, getTransacGroupby, deleteTransac } from '../API';
import DataTable from '../components/DataTable.js'

import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/fr';

import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { fr } from "react-day-picker/locale";

import { getWeekDays, getWeekRange } from '../helpers/daypicker-helper.js'

const Historique = () => {

  dayjs.extend(localizedFormat);

  const [transactions, setTransactions] = useState([]);
  const [weekStart, setWeekStart] = useState(() => getWeekRange(new Date()).from);
  const selectedDays = useMemo(() => getWeekDays(weekStart), [weekStart]);
  const [view, setView] = useState('transaction');
  const [loading, setLoading] = useState(true);

  const modifiers = {
    selectedWeek: (day) => {
      const dayStart = dayjs(day).startOf('day');
      const rangeStart = dayjs(weekStart).startOf('day');
      const rangeEnd = rangeStart.add(6, 'day');
      return !dayStart.isBefore(rangeStart) && !dayStart.isAfter(rangeEnd);
    }
  };

  useEffect(() => {
    setLoading(true);

    const from = dayjs(selectedDays[0]).format('YYYY-MM-DD');
    const to = dayjs(selectedDays[6]).format('YYYY-MM-DD');
    const fetchData = view === 'code' ? getTransacGroupby : getTransac;

    fetchData(from, to)
      .then((response) => {
        setTransactions(Array.isArray(response) ? response : []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [view, weekStart]);

  const handleViewChange = (nextView) => {
    if (nextView !== view) {
      setView(nextView);
    }
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    const id = e.currentTarget.id;
    const response = await deleteTransac({ id });

    if (response.ok) {
      setTransactions((rows) => rows.filter((row) => String(row.id) !== String(id)));
    }
  };

  const handleDayChange = (date) => {
    setWeekStart(getWeekRange(date).from);
  };

  const handleWeekClick = (weekNumber, days) => {
    if (days?.length) {
      setWeekStart(getWeekRange(days[0]).from);
    }
  };

  const weekLabel = `${dayjs(selectedDays[0]).locale('fr').format('LL')} – ${dayjs(selectedDays[6]).locale('fr').format('LL')}`;

  return (
    <div className="container historique-page">
      <header className="dashboard-page-header">
        <p className="page-eyebrow">Rapports</p>
        <h1>Historique</h1>
        <p className="page-lead">
          Sélectionnez une semaine pour consulter vos transactions et rapports.
        </p>
      </header>

      <section className="chart-card historique-calendar-card">
        <h2 className="historique-section-title">Calendrier</h2>
        <p className="historique-section-hint">Cliquez sur une date ou un numéro de semaine.</p>
        <div className="historique-calendar-wrap">
          <DayPicker
            showWeekNumber
            showOutsideDays
            modifiers={modifiers}
            modifiersClassNames={{ selectedWeek: 'historique-week-selected' }}
            onDayClick={handleDayChange}
            onWeekClick={handleWeekClick}
            weekStartsOn={0}
            locale={fr}
          />
        </div>
        <p className="historique-week-label">{weekLabel}</p>
      </section>

      <div className="historique-view-toggle" role="group" aria-label="Type de rapport">
        <button
          type="button"
          className={`historique-view-btn${view === 'transaction' ? ' historique-view-btn-active' : ''}`}
          onClick={() => handleViewChange('transaction')}
        >
          Par transaction
        </button>
        <button
          type="button"
          className={`historique-view-btn${view === 'code' ? ' historique-view-btn-active' : ''}`}
          onClick={() => handleViewChange('code')}
        >
          Par code
        </button>
      </div>

      {loading ? (
        <div className="chart-card historique-report-card">
          <p className="dashboard-loading historique-loading">Chargement...</p>
        </div>
      ) : (
        <DataTable
          transactions={transactions}
          selectedDays={selectedDays}
          viewFormat={view}
          handleDelete={handleDelete}
        />
      )}
    </div>
  );
};

export default Historique;
